import {CheckCircle, FileDownloadRounded, FileUploadRounded, WarningRounded} from "@mui/icons-material";


import {Button, Checkbox, Chip, Grid, IconButton, ListItemText, MenuItem, TextField} from "@mui/material";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import SectionHeader from "../../../../util/component/SectionHeader";
import {AgGridReact} from "ag-grid-react";
import * as React from "react";
import {useContext, useEffect, useMemo, useRef, useState} from "react";
import {ColDef, GetRowIdParams, GridApi, GridOptions, IServerSideGetRowsParams} from "ag-grid-enterprise";
import {useAgGridLocale, useHasScope} from "../../../../config/globalConfig";
import AdvancedFilter from "../../component/AdvancedFilter";
import * as Yup from 'yup';
import AgGridCustomTable from "../../../../util/component/AgGridCustomTable";
import {VOUCHER_PROVIDER_AMAZON} from "../../component/Constants";
import Stack from "@mui/material/Stack";
import {setSnackbar} from "../../../../util/state/globalAction";
import {snackbarTypes} from "../../../../util/state/globalVariables";
import {GlobalContext} from "../../../../util/state/GlobalContextProvider";
import CustomModal from "../../component/CustomModal";
import {useStatusValuesVoucher} from "../../component/useStatusValuesVoucher";
import {useVoucherActions} from "../../service/useVoucherActions";
import VoucherDetailModal from "./modal/VoucherDetailModal";
import {Voucher, VoucherAdvancedFilters, VoucherGelAllResponseResult, VoucherInputGetAll} from "./VoucherInterfaces";
import {useVoucherStatuses} from "./hooks/useVoucherStatuses";
import EmptyState from "../../../../util/component/EmptyState";
import ActionButtonWithTooltip, {ActionTypes} from "../../component/ActionButtonWithTooltip";
import {downloadTemplate as downloadVoucherTemplate, formatDate, intToFloatCurrency} from "../../component/Utils";
import {keyPrefixValues} from "../../component/ImportFromFileErrorsTable";

import useDownloadTemplate from "../../../salesmarketing/hooks/useDownloadTemplate";
import {useVoucherCustomerAssociated} from "./hooks/useVoucherCustomerAssociated";
import {useVoucherProviders} from "./hooks/useVoucherProviders";
import {useVoucherIsAmazonBusiness} from "./hooks/useVoucherIsAmazonBusiness";
import {useVoucherAmazonInvoiceStatuses} from "./hooks/useVoucherAmazonInvoiceStatuses";
import {DateTimePicker} from "@mui/x-date-pickers";

const VoucherListPage = () => {
    const {globalData} = useContext(GlobalContext);

    const {t} = useTranslation(['salesmarketing'], {keyPrefix: 'voucher'});
    const navigate = useNavigate();
    const {getVoucherList, downloadInvoice, exportVoucherList,downloadTemplate,importFile, getCategoriesBySegmentCode} = useVoucherActions();
    const {getStatusColorVoucher, getStatusLabelVoucher} = useStatusValuesVoucher();
    const [selectedVoucher, setSelectedvoucher] = useState<VoucherGelAllResponseResult['content'][0] | null>(null);
    const [voucherTableShouldUpdate, setVoucherTableShouldUpdate] = useState(false);
    const [openDetail, setOpenDetail] = useState(false);
    const filterDefaultValues: VoucherAdvancedFilters = {
        tenantIds: globalData?.user?.legalEntities?.map((le: any) => le.name),
        dealerIds: globalData?.user?.dealers?.map((d: any) => d.name),
        statuses: [], voucherCode: "", bookingNumber: "", providers: [], subName: "",
        subCategory: [], isCustomerAssociated: "",isAmazonBusiness:"", amazonInvoiceStatus: [],
        createdDateFrom: null, createdDateTo: null, lastModifiedDateFrom: null, lastModifiedDateTo: null
    };
    const [filters, setFilters] = useState<VoucherAdvancedFilters>(filterDefaultValues);
    const [searchInput, setSearchInput] = useState("");
    const [openUploadWarning, setOpenUploadWarning] = useState(false);
    const [fileForImport, setFileForImport] = useState<File | undefined>(undefined);
    const {dispatchGlobalData} = useContext(GlobalContext);
    const hasScope = useHasScope;
    const [enableAsociatedCustomer, setEnableAssociatedCustomer] = useState(false);
    const [enableAmazonInvoiceStatus, setEnableAmazonInvoiceStatus] = useState(false);
    const [enableIsAmazonBusiness, setEnableIsAmazonBusiness] = useState(false);
    const agGridLocale = useAgGridLocale();
    const gridRef = useRef<AgGridReact>(null);

    const {statuses} = useVoucherStatuses();
    const {amazonInvoiceStatuses} = useVoucherAmazonInvoiceStatuses();
    const {providersValues} = useVoucherProviders();
    const {customerAssociatedFilterValues} = useVoucherCustomerAssociated();
    const {isAmazonBusinessFilterValues} = useVoucherIsAmazonBusiness()
    const [categories, setCategories] = useState<any[]>([]);
    const {importFromFileResponseResultStatus:voucherImportFromFileResponseResultStatus,renderModalContent:renderVoucherModalContent} = useDownloadTemplate(
        keyPrefixValues.VOUCHER,
        fileForImport,
        setFileForImport,
        importFile,
        (numberOfInsertedVouchers:number) =>  t(`importSuccess.content`, {count: numberOfInsertedVouchers}),
        setOpenUploadWarning,
        setVoucherTableShouldUpdate,
    )

    useEffect(() => {
        if (voucherTableShouldUpdate) {
            gridRef?.current?.api?.setServerSideDatasource(createDatasource(filters, gridRef.current!.api));
            setVoucherTableShouldUpdate(false);
        }
    }, [voucherTableShouldUpdate]);

    useEffect(() => {
        getCategoriesBySegmentCode().then((res: any) => {
            setCategories(res);
        })
    }, []);

    const columns: ColDef[] = [
        {
            field: "tenantId",
            headerName: t('listColumns.legalEntityField'),
            hide: globalData?.user?.legalEntities?.length <= 1,
            unSortIcon: true,
            cellRenderer: (params: any) => {
                return globalData?.user?.legalEntities.find((le: any) => le.name === params.data.tenantId)?.name
            },
            tooltipValueGetter: (params: any) => {
                return globalData?.user?.legalEntities.find((le: any) => le.name === params.data.tenantId)?.name
            }
        },
        {
            field: "dealerId",
            headerName: t('listColumns.dealerField'),
            hide: globalData?.user?.dealers?.length <= 1,
            unSortIcon: true,

        },
        {
            field: "code",
            headerName: t('listColumns.voucherCodeField'),
            unSortIcon: true,
        },
        {
            field: "provider",
            headerName: t('listColumns.providerField'),
            unSortIcon: true,
        },
        {
            field: "bookingCode",
            headerName: t('listColumns.bookingNumberField'),
            unSortIcon: true,
        },

        {
            field: "subCategory",
            headerName: t('listColumns.categoryField'),
            unSortIcon: true,
        },
        {
            field: "subName",
            headerName: t('listColumns.subscriptionfield'),
            unSortIcon: true,
        },
        {
            field: "price",
            headerName: t('listColumns.priceField'),
            cellRenderer: (params: any) =>  params.value ? intToFloatCurrency(params.value.toString()) : "",
            unSortIcon: true,
        },
        {
            field: "createdDate",
            headerName: t('listColumns.createdDate'),
            unSortIcon: true,
            valueFormatter: (params: any) => formatDate(params.value),
        },
        {
            field: "lastModifiedDate",
            headerName: t('listColumns.lastModifiedDate'),
            unSortIcon: true,
            valueFormatter: (params: any) => formatDate(params.value),
        },
        /* {
             field: "creditNote",
             headerName: t('listColumns.creditNoteField'),
             tooltipField: "address",
             unSortIcon: true
         },*/
        {
            field: "status",
            maxWidth: 160,
            headerName: t('listColumns.statusField'),
            pinned: 'right',
            lockPosition: 'right',
            lockPinned: true,
            cellClass: "grid-cell-center",
            headerClass: "grid-header-center",
            unSortIcon: true,
            cellRenderer: (params: any) => {
                return <Chip label={getStatusLabelVoucher(params.data.status.toUpperCase())}
                             sx={{backgroundColor: getStatusColorVoucher(params.data.status.toUpperCase())}}/>
            }
        },
        {
            field: "_actions",
            maxWidth: 160,
            headerName: t('listColumns.actionsField'),
            pinned: 'right',
            lockPosition: 'right',
            lockPinned: true,
            sortable: false,
            cellRenderer: (params: { data: Voucher }) => {
                return (
                    <Stack direction={"row"} justifyContent={"center"}>
                        <ActionButtonWithTooltip type={ActionTypes.edit} callback={() => {
                            window.open(`/salesmarketing/voucherupdate/${params.data.id}`, "_blank");
                        }} auth={'SCOPE_SM_UPDATE_VOUCHER'}/>
                        <ActionButtonWithTooltip type={ActionTypes.invoice}
                                                 callback={() => onDownloadInvoice(params.data.invoiceId)}
                                                 disabled={!params.data.invoiceId} auth={'SCOPE_SM_VOUCHER_DOWNLOAD_INVOICE'}/>
                        <ActionButtonWithTooltip type={ActionTypes.details} callback={() => {
                            setOpenDetail(true);
                            setSelectedvoucher(params.data);
                        }} auth={'SCOPE_SM_VIEW_VOUCHER_DETAIL'}/>
                    </Stack>
                );
            }
        },
        {
            field: "error",
            maxWidth: 100,
            headerName: t('listColumns.errorField'),
            cellClass: "ag-grid-cell-error",
            pinned: 'right',
            lockPosition: 'right',
            lockPinned: true,
            sortable: false,
            hide: true,
            cellRenderer: (params: { data: Voucher }) => {
                return (
                    <Stack direction={"row"} justifyContent={"center"}>
                        {params.data.invoiceStatusNote && <IconButton color={"secondary"} sx={{pointerEvents: "none"}}>
                            <WarningRounded/>
                        </IconButton>
                        }
                    </Stack>
                );
            }
        }
    ];

    function createDatasource(filters: VoucherAdvancedFilters, api: GridApi) {
        return {
            getRows: async (params: IServerSideGetRowsParams) => {
                let filterTemp: VoucherInputGetAll = {...filters};
                filterTemp.offset = params.request.startRow ? params.request.startRow : 0;
                filterTemp.limit = (params.request.endRow ? params.request.endRow : 10) - filterTemp.offset;
                filterTemp.sort = params.request.sortModel.length === 0 ? null : params.request.sortModel[0].colId;
                filterTemp.order = params.request.sortModel.length === 0 ? null : params.request.sortModel[0].sort;
                filterTemp.search = searchInput;
                try {
                    let data = await getVoucherList(filterTemp);
                    params.success({
                        rowData: data?.content,
                        rowCount: data?.totalElements
                    });
                    if (data.totalElements === 0) {
                        api.showNoRowsOverlay();
                    } else {
                        api.hideOverlay();
                    }
                } catch (e) {
                    params.fail();
                }
            }
        };
    }

    const gridOptions: GridOptions = {
        getRowId: (params: GetRowIdParams) => params.data['id'],
        suppressRowClickSelection: true,
        domLayout: 'autoHeight',
        rowModelType: 'serverSide',
        pagination: true,
        paginationPageSize: 10,
        cacheBlockSize: 10,
        defaultColDef: {
            sortable: true,
            resizable: true,
            wrapHeaderText: true
        },
        columnDefs: columns,
        serverSideInfiniteScroll: true,
        localeText: agGridLocale,
        noRowsOverlayComponentParams: {title: t('noRows')}
    };

    useEffect(() => {
        gridRef?.current?.api?.setServerSideDatasource(createDatasource(filters, gridRef.current!.api));
    }, [filters]);

    const noRowsOverlayComponent = useMemo<any>(() => {
        return EmptyState;
    }, []);


    const validationObj = {
        status: Yup.array(),
        subscription: Yup.string().nullable(),
        code: Yup.string().nullable(),
        bookingNumber: Yup.string().nullable(),
        category: Yup.string().nullable(),
        providers: Yup.array(),
        isCustomerAssociated:Yup.string().nullable(),
        isAmazonBusiness:Yup.string().nullable(),
        createdDateFrom: Yup.date().nullable()
            .test("testCreatedDateFrom", t('filters.invalidDate'), (value, context) => {
                return (!value || !context.parent.createdDateTo || value <= context.parent.createdDateTo)
            })
            .typeError(t('filters.invalidDate')),
        createdDateTo: Yup.date().nullable()
            .test("testCreatedDateTo", t('filters.invalidDate'), (value, context) => {
                return (!value || !context.parent.createdDateFrom || value >= context.parent.createdDateFrom)
            })
            .typeError(t('filters.invalidDate')),
        lastModifiedDateFrom: Yup.date().nullable()
            .test("testLastModifiedDateFrom", t('filters.invalidDate'), (value, context) => {
                return (!value || !context.parent.lastModifiedDateTo || value <= context.parent.lastModifiedDateTo)
            })
            .typeError(t('filters.invalidDate')),
        lastModifiedDateTo: Yup.date().nullable()
            .test("testLastModifiedDateTo", t('filters.invalidDate'), (value, context) => {
                return (!value || !context.parent.lastModifiedDateFrom || value >= context.parent.lastModifiedDateFrom)
            })
            .typeError(t('filters.invalidDate')),
    }

    const renderSubscription = (field: any) => (
        <TextField
            fullWidth
            label={t('filters.subscription')}
            value={field.value}
            onChange={field.onChange}
        />
    )


    const renderStatus = (field: any) => (
        <TextField
            fullWidth
            label={t('filters.status')}
            select
            SelectProps={{
                multiple: true,
                renderValue: (selected: any) => selected.map((s: any) => statuses.find(ss => ss.value === s)!.label).join(', ')
            }}
            value={field.value}
            onChange={field.onChange}
        >
            {statuses?.map((status) => (
                <MenuItem key={status.value} value={status.value}>
                    <Checkbox checked={field.value.indexOf(status.value) > -1}/>
                    <span style={{
                        border: "1px solid " + status.color,
                        backgroundColor: status.color,
                        borderRadius: "50%",
                        display: "inline-block",
                        height: "14px",
                        width: "14px",
                        marginRight: "5px"
                    }}/>
                    <ListItemText primary={status.label}/>
                </MenuItem>
            ))}
        </TextField>
    )


    const renderProviders = (field: any) => {
        return <TextField
            fullWidth
            label={t('filters.providers')}
            select
            SelectProps={{
                multiple: true,
                renderValue: (selected: any) => selected.map((selectedProvider: any) => providersValues.find((provider) => provider.value === selectedProvider)!.label).join(', ')
            }}
            value={field.value}
            onChange={(e) => {
                const  selectedProviderValue = e.target.value;
                 if(selectedProviderValue.includes(VOUCHER_PROVIDER_AMAZON)) {
                     setEnableAssociatedCustomer(true);
                     setEnableIsAmazonBusiness(true);
                     setEnableAmazonInvoiceStatus(true);
                } else {
                     setEnableAssociatedCustomer(false);
                     setEnableIsAmazonBusiness(false);
                     setEnableAmazonInvoiceStatus(false);
                 }
                field.onChange(e);
            }}
        >


            {providersValues?.map((provider: any) => (
                <MenuItem key={provider.value} value={provider.value}>
                    <Checkbox color={"accent"}
                              checked={field.value?.indexOf(provider.value) > -1}/>
                    <ListItemText primary={getStatusLabelVoucher(provider.value)}/>
                </MenuItem>
            ))}
        </TextField>
    }


    const renderVoucherCode = (field: any) => (
        <TextField
            fullWidth
            label={t('filters.voucherCode')}
            value={field.value}
            onChange={field.onChange}
        />
    )

    const renderBookingNumber = (field: any) => (
        <TextField
            fullWidth
            label={t('filters.bookingNumber')}
            value={field.value}
            onChange={field.onChange}/>
    )

    const renderCategory = (field: any) => (
        <TextField
            fullWidth
            label={t('filters.category')}
            select
            SelectProps={{
                multiple: true,
                renderValue: (selected: any) => selected.join(', ')
            }}
            value={field.value}
            onChange={field.onChange}
        >
            {categories?.map((category) => (
                <MenuItem key={category.categoryCode} value={category.categoryName}>
                    <Checkbox checked={field.value.indexOf(category.categoryName) > -1}/>
                    <ListItemText primary={category.categoryName}/>
                </MenuItem>
            ))}
        </TextField>
    )

    const renderIsAmazonBusiness = (field: any) => (
        <TextField fullWidth
                   select
                   disabled={!enableIsAmazonBusiness}
                   SelectProps={{
                       multiple: false
                   }}
                   label={t("filters.isAmazonBusiness")}
                   value={field.value}
                   onChange={field.onChange}
        >
            <MenuItem value={""}>
                <em/>
            </MenuItem>
            {isAmazonBusinessFilterValues.map((c) => (
                <MenuItem key={c.value} value={c.value}>
                    {c.label}
                </MenuItem>
            ))}
        </TextField>
    );

    const renderAmazonInvoiceStatus = (field: any) => (
        <TextField
            fullWidth
            label={t('filters.amazonInvoiceStatus')}
            select
            disabled={!enableAmazonInvoiceStatus}
            SelectProps={{
                multiple: false,
            }}
            value={field.value}
            onChange={field.onChange}
        >
            {amazonInvoiceStatuses?.map((status) => (
                <MenuItem key={status.value} value={status.value}>
                    {status.label}
                </MenuItem>
            ))}
        </TextField>
    )

    const renderCreatedDateFrom = (field: any, error: any, formState: any, values: any) => (
            <DateTimePicker
                label={t('filters.createdDateFrom')}
                value={field.value}
                maxDate={values["createdDateTo"] !== null ? values["createdDateTo"] : null}
                onChange={field.onChange}
                ampm={false}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        fullWidth
                        id={"createdDateFrom"}
                        error={error !== undefined}
                        helperText={error ? error.message : ""}
                    />
                )}
                inputFormat={"DD/MM/YYYY HH:mm"}
            />
    )
    const renderCreatedDateTo = (field: any, error: any, formState: any, values: any) => (
        <DateTimePicker
            label={t('filters.createdDateTo')}
            value={field.value}
            minDate={values["createdDateFrom"] !== null ? values["createdDateFrom"] : null}
            onChange={field.onChange}
            ampm={false}
            renderInput={(params) => (
                <TextField
                    {...params}
                    fullWidth
                    id={"createdDateTo"}
                    error={error !== undefined}
                    helperText={error ? error.message : ""}
                />
            )}
            inputFormat={"DD/MM/YYYY HH:mm"}
        />
    )
    const renderLastModifiedDateFrom = (field: any, error: any, formState: any, values: any) => (
        <DateTimePicker
            label={t('filters.lastModifiedDateFrom')}
            value={field.value}
            maxDate={values["lastModifiedDateTo"] !== null ? values["lastModifiedDateTo"] : null}
            onChange={field.onChange}
            ampm={false}
            renderInput={(params) => (
                <TextField
                    {...params}
                    fullWidth
                    id={"lastModifiedDateFrom"}
                    error={error !== undefined}
                    helperText={error ? error.message : ""}
                />
            )}
            inputFormat={"DD/MM/YYYY HH:mm"}
        />
    )

    const renderLastModifiedDateTo = (field: any, error: any, formState: any, values: any) => (
        <DateTimePicker
            label={t('filters.lastModifiedDateTo')}
            value={field.value}
            minDate={values["lastModifiedDateFrom"] !== null ? values["lastModifiedDateFrom"] : null}
            onChange={field.onChange}
            ampm={false}
            renderInput={(params) => (
                <TextField
                    {...params}
                    fullWidth
                    id={"lastModifiedDateTo"}
                    error={error !== undefined}
                    helperText={error ? error.message : ""}
                />
            )}
            inputFormat={"DD/MM/YYYY HH:mm"}
        />
    )

    const fields = {
        statuses: renderStatus,
        subName: renderSubscription,
        voucherCode: renderVoucherCode,
        bookingNumber: renderBookingNumber,
        subCategory: renderCategory,
        providers: renderProviders,
        isAmazonBusiness:renderIsAmazonBusiness,
        amazonInvoiceStatus: renderAmazonInvoiceStatus,
        createdDateFrom: renderCreatedDateFrom,
        createdDateTo: renderCreatedDateTo,
        lastModifiedDateFrom: renderLastModifiedDateFrom,
        lastModifiedDateTo: renderLastModifiedDateTo
    }

    const toolbar = {
        renderActions: () => <>
                {hasScope('SCOPE_SM_VOUCHER_DOWNLOAD_TEMPLATE') &&
                    <Button sx={{whiteSpace:'nowrap'}} fullWidth variant={"outlined"} size="small" onClick={() => downloadVoucherTemplate(downloadTemplate,dispatchGlobalData,setSnackbar,snackbarTypes,t("downloadError"))}
                            startIcon={<FileDownloadRounded/>}>
                        {t('buttons.downloadCsvTemplate')}
                    </Button>
                }
                {hasScope('SCOPE_SM_IMPORT_VOUCHER') &&
                    <Button sx={{whiteSpace:'nowrap'}} fullWidth variant={"outlined"} size="small" component="label" onClick={()=> console.log('inport button clicked')} startIcon={<FileUploadRounded/>}>
                        {t('buttons.importFromFile')}
                        <input onChange={(event) => {
                              console.log('Event reached: ' + event)
                            setFileForImport(event?.target?.files?.[0]);
                            const element = event.target as HTMLInputElement
                            element.value = '';
                        }} hidden accept=".xlsx" multiple type="file"/>
                    </Button>
                }
                {hasScope('SCOPE_SM_EXPORT_VOUCHER') &&
                <Button sx={{whiteSpace:'nowrap'}} fullWidth variant={"outlined"} size="small" onClick={() => onExportVoucherList(filters)}
                        startIcon={<FileDownloadRounded/>}>
                    {t('buttons.exportVoucherList')}
                </Button>
                }
        </>

    }

    const onDownloadInvoice = async (invoiceId: number) => {
        try {
            const {result} = await downloadInvoice(invoiceId);
            if (result) {
                let pdfWindow = window.open("");
                pdfWindow!.document.write(`<iframe width='100%' height='100%' src='data:application/pdf;base64, ${encodeURI(result)}'></iframe>`);
            }
        } catch (err) {
            dispatchGlobalData({
                type: setSnackbar,
                payload: {
                    snackbar: {
                        message: t("downloadError"),
                        type: snackbarTypes.error,
                        show: true,
                        autoClose: true,
                    }
                }
            });

        }
    }

    const onExportVoucherList = async (filters: VoucherAdvancedFilters) => {
        try {
            const {result} = await exportVoucherList(filters);
            var mediaType = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
            // create "a" HTML element with href to file & click
            const link = document.createElement('a');
            link.href = mediaType + result.filecontent;
            console.warn(link.href)
            link.setAttribute('download', result.filename);
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
        } catch (err) {
            dispatchGlobalData({
                type: setSnackbar,
                payload: {
                    snackbar: {
                        message: t("downloadVoucherListError"),
                        type: snackbarTypes.error,
                        show: true,
                        autoClose: true,
                    }
                }
            });
        }
    }

    const reset = () => {
        setEnableAssociatedCustomer(false);
        setEnableAmazonInvoiceStatus(false);
        setEnableIsAmazonBusiness(false);
    };

    return (
        <>
            <SectionHeader title={t('listHeader.title')}
                           subtitle={t('listHeader.subTitle')}/>

            <AdvancedFilter validationObj={validationObj} fields={fields} defaultValues={filterDefaultValues}
                            searchInput={searchInput} setSearchInput={setSearchInput} filters={filters}
                            setFilters={setFilters} onReset={reset}/>

            <Grid container>
                <Grid item xs={12} sx={{padding: "16px"}}>
                    <AgGridCustomTable
                        gridOptions={gridOptions} gridRef={gridRef} toolbar={toolbar}
                        noRowsOverlayComponent={noRowsOverlayComponent}
                        onGridReady={(params) => {
                            params.api.setServerSideDatasource(createDatasource(filters, gridRef.current!.api));
                        }}
                    />
                </Grid>
            </Grid>
            {selectedVoucher &&
                <VoucherDetailModal key={selectedVoucher.id} open={openDetail}
                                    handleClose={() => setOpenDetail(false)}
                                    voucher={selectedVoucher}
                />
            }

            <CustomModal open={openUploadWarning} onClose={() => setOpenUploadWarning(false)}
                         title={voucherImportFromFileResponseResultStatus.isImportFromFileSuccess ? t('importSuccess.title') : t('importErrors.title')}
                         cancelButton={t('buttons.close')}
                         content={renderVoucherModalContent}
                         titleIcon={!voucherImportFromFileResponseResultStatus.isImportFromFileSuccess ? <WarningRounded color={"error"}/> : <CheckCircle color={"success"}/>}
            />
        </>
    );
}

export default VoucherListPage;